"use strict";
/// <reference path="../typing/index.d.ts"/>

import * as Jshashes from "jshashes";

const sha512 = new Jshashes.SHA512();
const passwordBOSalt = "psg.shdd";

export function hashPassphrase(pwd: string) {
  return sha512.hex(`${pwd}{${passwordBOSalt}}`);
}



// WEBPACK FOOTER //
// ./src/helpers/password-hasher.ts